import { ENV } from './types';

// test1|test2|test3.jd.com
const ACORE_DOMAIN: string = '//test1.yx.jd.com';

const TREND_DOMAIN: string = '//test1.yx.jd.com';

const HD_API_DOMAIN: string = '//test-actcenter.jd.com';

const HD_API_TOOL_DOMAIN: string = '//beta-asta.jd.com';

const MC_DOMAIN: string = '//test.mc.jd.com';

const ACE_DOMAIN: string = '//beta-ace.jd.com';

const ACE_API_DOMAIN: string = '//beta-mc.jd.com';

const BABEL_DOMAIN: string = '//betah5.m.jd.com';

const LINGLONG_DOMAIN: string = '//ling-test.jd.com';

const BABELPRO_DOMAIN: string = 'https://beta-pro.m.jd.com';

const BABELPRO_PC_DOMAIN: string = 'https://a-pro.jd.com';

const BABELPRO_PARAMS: string = '?env=beta';

const CELUE_DOMAIN = '//beta-smartcms.jd.com';

const QYPT_DOMAIN = '//qypt-test.jd.com';

const WAREOPS_DOMAIN = '//beta-ioc.jd.com';
const DATA_CENTER_DOMAIN = '//marking.center.jd.com';
const EASYBI_DOMAIN = '//jdp-uat.jd.com';
const EASYBI_URL_DOMAIN = 'http://easybi.jd.com';

const BAICHUAN_DOMAIN = '//beta-bcms.jd.com/0/menuManage';
const SECKILLCMS_DOMAIN = '//seckillcmsyx.jd.com';
const DRIPWORKS_DOMAIN = '//dripworks-tk-test-pro.beta-pf.jd.com';

const NEWPROCESS = 'http://dripworks-111-beta.local-pf.jd.com';

const NEWZHENDI = '//test1.yx.jd.com/platform-marketing/CA033010185874206204';

// 黄金流程数字化服务平台【我京cms配置】
const WEJDPlat_DOMAIN: string = 'http://beta-plat.jd.com';

// 频道标签平台
const EASYLABELPLAT_DOMAIN: string = 'http://easylabel-dev.jd.com';
// 三超CMS【京东三超】
const CICADA_DOMAIN: string = 'https://cicada-beta.local-pf.jd.com';

const value: ENV = {
  ACORE_DOMAIN,
  TREND_DOMAIN,
  HD_API_DOMAIN,
  DATA_CENTER_DOMAIN,
  EASYBI_DOMAIN,
  EASYBI_URL_DOMAIN,
  MC_DOMAIN,
  ACE_DOMAIN,
  ACE_API_DOMAIN,
  BABEL_DOMAIN,
  LINGLONG_DOMAIN,
  BABELPRO_DOMAIN,
  BABELPRO_PARAMS,
  BABELPRO_PC_DOMAIN,
  CELUE_DOMAIN,
  QYPT_DOMAIN,
  WAREOPS_DOMAIN,
  BAICHUAN_DOMAIN,
  SECKILLCMS_DOMAIN,
  DRIPWORKS_DOMAIN,
  NEWPROCESS,
  NEWZHENDI,
  WEJDPlat_DOMAIN,
  EASYLABELPLAT_DOMAIN,
  CICADA_DOMAIN,
  HD_API_TOOL_DOMAIN,
};

export default value;
